export default __webpack_public_path__ + "student-tutor.png";